<div  id="mini_player_root">
  @if (!showExpandedPlayer && !universalService.isMobileDevice) {
    <div class="audio_mini_player_container" id="mini_player" (mouseover)="showExpandedPlayer=true">
      <div class="circleProgressContainer" >
        <div class="progress audio_progress"></div>
      </div>
      <div class="default-audio-icon-holder" >
        <span class="NeueAudio"></span>
        <img [ngStyle]="{'background-size':'100%','background-image': getBackgroundImageUrl() }" class="audio-mini-player-thumbnail mr-2"  onerror="this.style.display = 'none'" />
      </div>
    </div>
  }

  @if (showExpandedPlayer || universalService.isMobileDevice) {
    <div class="expandedMiniPlayer pseudo-audiominiplayer" (mouseleave)="showExpandedPlayer=false" ><!---->
      <div class="circleProgressContainer" (click)="showFullScreenAudioPlayer()">
        <div class="progress audio_progress"></div>
      </div>
      <div class="default-audio-icon-holder">
        <div id="songProgressCont"></div>
        <span class="NeueAudio"></span>
        <img [ngStyle]="{'background-size':'100%','background-image': getBackgroundImageUrl() }" class="audio-mini-player-thumbnail mr-2"  onerror="this.style.display = 'none'" />
      </div>
      <marquee class="audioLabel">
        {{ universalService.selectedAudioFile.objectName }}
      </marquee>
      <div class="mini_player_controls">
        <span class="Neueprevious" title="Previous" (click)="clapprImpl.fetchFile('fetchPrevious')"></span>
        <div class="audioPoster miniAudioScreen">
          @if (!clapprImpl.audioPlaying) {
            <i class="NeuePlayFilled" title="Play" (click)="clapprImpl.playPauseAudio()"></i>
          }
          @if (clapprImpl.audioPlaying) {
            <i class="NeuePause" title="Pause" (click)="clapprImpl.playPauseAudio();universalService.isManualPause=true"></i>
          }
        </div>
        <span class="Neuenext" title="Next" (click)="clapprImpl.fetchFile('fetchNext')"></span>
      </div>
      <span class="NeueFile_Cancel" title="Close" (click)="closeMiniPlayer()"></span>
    </div>
  }
</div>
